
import { defineComponent, onMounted, SetupContext } from 'vue'
import { useRouter } from 'vue-router'
import GoalButtons from '@/components/block/GoalButtons.vue'
import SnsRegistButtons from '@/components/block/SnsRegistButtons.vue'
import TextBlock from '@/components/block/TextBlock.vue'
import HeadingLv3 from '@/components/elements/HeadingLv3.vue'
import Button from '@/components/elements/Button.vue'
import HrBlock from '@/components/elements/HrBlock.vue'
import { getCookieValue } from '@/utils/cookie'

export default defineComponent({
  name: 'RegistSelect',

  components: {
    GoalButtons,
    SnsRegistButtons,
    TextBlock,
    HeadingLv3,
    Button,
    HrBlock
  },

  props: {
    data: Object,
    state: {
      type: Object,
      require: true
    }
  },

  setup(props: any, context: SetupContext) {
    const router = useRouter()
    // 入力ページ経由じゃない場合は弾く
    // if (!props.state.isLandingInput) {
    //   router.replace('/500')
    // }

    const goBack = () => {
      router.push('/register/terms')
    }

    const goForward = () => {
      // NOTE: メールアドレス登録に移動する前にsocialplus_idを削除
      context.emit('update-profile', 'socialplus_id', '')
      router.push('/register/profile')
    }

    const goToSocialPlus = () => {
      document.cookie = `hopeKeywords=${props.data.hopeKeywords}; max-age=3600`
      document.cookie = `memberType=${props.data.memberType}; max-age=3600`
      document.cookie = `hopePrefectures=${props.data.hopePrefectures}; max-age=3600`
      document.cookie = `invitationCode=${props.data.invitationCode}; max-age=3600`
      location.href = `https://ca68f31f7a.auth.socialplus.jp/mynavi_resident/mynavi_resident_usr/line/authenticate?callback=${process.env.VUE_APP_URL}/register/profile&extended_items=real_name,gender,birthdate,address,email,phone`
    }

    onMounted(() => {
      context.emit('update-flow', 3)

      // NOTE: メモリ上にmemberTypeがない場合はcookieから再取得を試みる
      if (props.data.memberType) return
      context.emit('update-member-type', getCookieValue('memberType'))
    })

    return {
      goToSocialPlus,
      goBack,
      goForward
    }
  }
})
